/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_KuerzelInputs */

const de__field_kuerzel = /** @type {(inputs: _Field_KuerzelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kürzel`)
};

/**

* @param {_Field_KuerzelInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_kuerzel = /** @type {((inputs?: _Field_KuerzelInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_KuerzelInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_kuerzel(inputs)
});